import { Component } from '@angular/core';

@Component({
  selector: 'app-sail-loader',
  standalone: true,
  imports: [],
  templateUrl: './sail-loader.component.html',
  styleUrl: './sail-loader.component.scss'
})
export class SailLoaderComponent {

}
